
// Vue
import { Component, Mixins } from 'vue-mixin-decorator';
import { Watch } from 'vue-property-decorator';
// Route
import { RouteConsts } from '@/routes/route';
// Component
import BasePage from '@/pages/BasePage.vue';
// CMS
import { News, Product } from '@/apis/cms';

// lodash
import orderBy from 'lodash/orderBy';
import { AltContents } from '@/common/alternatives';

@Component
export default class TopPage extends Mixins<BasePage>(BasePage) {
  private importantNotice: string = '';
  private informations: Array<News> = [];
  private apis: Array<Product> = [];
  private offset: number = 0;
  private isMoreBtnVisible: boolean = true;
  private importantNoticeHeight: number = 0;

  //TODO
  // プロダクトのTypeをMicroCMS側でセレクトに変更するタイミングで
  // セレクト定義のenumからタイプ判定を行うようにする
  private openProductTypes = [
    'InHouseAPI',
    '3rdPartyAPI',
    'Software',
    'ComingSoon'
  ];

  @Watch('importantNotice')
  private setImportantNotice() {
    this.$nextTick(() => {
      this.importantNoticeHeight = (this.$refs
        .importantNotice as HTMLDivElement).clientHeight;
    });
  }

  /**
   * 商品詳細画面遷移
   */
  private goToProductDetail(productId: string) {
    this.$router.push({
      name: RouteConsts.ProductDetailPage,
      params: { product_id: productId }
    });
  }

  private goToTutorials() {
    this.$router.push({
      name: RouteConsts.TutorialsPage
    });
  }

  /**
   * 重要なお知らせ取得
   */
  private async getImportantNotice() {
    // CMS API呼び出し
    const httpClient = await this.$cmsClient();
    const importantNotice = await httpClient.notice
      .getNotice()
      .then(res => {
        const { data } = res;
        return data;
      })
      .catch(err => {
        if (err.response && err.response.status === 404) {
          return AltContents.Notice404Response;
        }
        return AltContents.NoticeResponse;
      });

    return importantNotice.content ? importantNotice.content : '';
  }

  /**
   * ニュース取得
   */
  private async getNews() {
    // CMS API呼び出し
    const httpClient = await this.$cmsClient();
    const news = await httpClient.news
      .getNews()
      .then(res => {
        const { data } = res;
        return orderBy(data.contents, 'date', 'desc');
      })
      .catch(() => {
        return [] as News[];
      });

    return news;
  }

  /**
   * 内部サイトチェック
   */
  private isInternalLink(path: string): boolean {
    return !/^https?:\/\//.test(path);
  }

  /**
   * 商品取得
   */
  private async getProducts() {
    // CMS API呼び出し
    const cmsHttpClient = await this.$cmsClient();
    const limit = 999;
    const contents = await cmsHttpClient.product
      .getProducts(limit)
      .then(res => {
        const { data } = res;
        return data.contents;
      })
      .catch(() => {
        return [] as Product[];
      });

    //検索結果なしの場合、処理不要
    if (contents.length === 0) {
      return [];
    }

    // 設定されたタイプが不正でないコンテンツのみに絞る
    const openContents = contents.filter(content => {
      let type = '';
      if (content.type) {
        type = content.type[0];
      }
      return this.openProductTypes.includes(type);
    });

    // ソート
    return orderBy(openContents, 'order') as Product[];
  }

  async created() {
    // 初期表示 APIコール
    this.importantNotice = await this.getImportantNotice();
    this.informations = await this.getNews();
    this.apis = await this.getProducts();
  }
}
